import React from 'react';
import { Loader } from 'modules/ui';
import { LeasingCalculatorSelectors } from 'modules/leasingCalculator/redux';
import { InfoCard } from 'modules/ui/infoCard';
import { InfoCardType } from 'modules/ui/infoCard/components/InfoCardType';
import { useTranslation } from 'react-i18next';
import { LeasingCalculatorSharedFormProps } from '../../common/LeasingCalculatorData';
import { LeasingOfferOverviewLayout } from '../../../../leasingOfferOverviewPage/components/layout';
import { useAppSelector } from '../../../../hooks/appHooks';
import { InfoCardWrapper } from './styled';

export interface LeasingCalculatorOfferDataProps
  extends Omit<LeasingCalculatorSharedFormProps, 'onChange'> {}

export const LeasingCalculatorOfferData: React.FC<
  LeasingCalculatorOfferDataProps
> = ({ onPreviousStep, onSubmit }) => {
  const leasingOfferDetailsLoading = useAppSelector(
    LeasingCalculatorSelectors.selectProductSelectionDataLoading,
  );
  const leasingOfferDetails = useAppSelector(
    LeasingCalculatorSelectors.selectProductSelectionDataResult,
  );

  const { t } = useTranslation();

  return (
    <Loader active={leasingOfferDetailsLoading}>
      <InfoCardWrapper>
        <InfoCard
          title={t('leasingCalculator.offerData.infoCardTitle')}
          description={t('leasingCalculator.offerData.infoCardDescription')}
          type={InfoCardType.CardWidePlainTeal}
        />
      </InfoCardWrapper>

      <LeasingOfferOverviewLayout
        onSubmit={onSubmit}
        onPrevious={onPreviousStep}
        data={leasingOfferDetails}
      />
    </Loader>
  );
};
